<div class="box-white-rounded-xs p-3 mt-3">
  <div class="row align-items-center py-2">
    <div class="col fs-18">
      {{
        brandOverride(
          'product.' +
            getProductByModelIdentifier(
              config!.modelIdentifier!
            )!.getProductKey() +
            '.title' | translate
        )
      }}
      - {{ config!.title | translate }}
    </div>
    @if (config?.enabledTotal && totalValue) {
      <div class="col-auto">
        <span>Total : </span>
        <span class="fw-bold color-primary">{{ totalValue }}</span
        >,
        <span class="fw-bold color-blue">{{ totalValue2 }}</span>
      </div>
    }
  </div>

  <div class="graph position-relative">
    <canvas #chart style="height: 350px"></canvas>

    @if (isLoading) {
      <div
        class="position-absolute top-0 start-0 bottom-0 end-0 text-center"
        style="z-index: 100; background-color: white"
      >
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col text-center">
            <ion-spinner name="circular"></ion-spinner>
          </div>
        </div>
      </div>
    }
  </div>
</div>
